import React, { useState, useEffect } from 'react';
import HamburgerMenu from './hamburger';
function HamburgerMenuWrapper(props) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // The useEffect Hook runs after the component output has been rendered to the DOM.
    // This is a good place to set the isClient state to true.
    setIsClient(true);
  }, []);

  return (
    <>
      {isClient && <HamburgerMenu { ...props }/>}
    </>
  );
}

export default HamburgerMenuWrapper;
